import { Footer } from "@/src/components/ui/footer";
import { Input } from "@/src/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";
import { Content } from "@/src/components/wrappers/Content";
import { ActionsContext, useEmit } from "@/src/lib/actions";
import { useDebounce } from "@/src/lib/useDebounce";
import { ChangeEvent, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { isUuid } from "./utils";
import { arrayLast } from "@/src/lib/utils";
import { Button } from "@/src/components/ui/button";
import { PlusIcon } from "lucide-react";
import { ExportLocationsButton } from "./components/ExportLocationsButton";

export function Locations() {
  const res = useLocation();

  const lastSegment = arrayLast(res.pathname.split("/"))!;
  const isDetailsView = lastSegment === "add" || isUuid(lastSegment);

  return (
    <ActionsContext>
      <Content title="Locations">
        {!isDetailsView && <TableControls />}
        <Outlet />
        <Footer />
      </Content>
    </ActionsContext>
  );
}
function TableControls() {
  const navigate = useNavigate();
  const res = useLocation();

  return (
    <div className="mb-2 flex justify-between items-center">
      <div className="flex flex-row gap-2 items-center">
        <Select onValueChange={(value) => navigate(value)} value={res.pathname}>
          <SelectTrigger className="w-48">
            <SelectValue placeholder="Select location type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="/locations">Locations</SelectItem>
            <SelectItem value="/locations/towns">Towns</SelectItem>
            <SelectItem value="/locations/regions">Regions</SelectItem>
            <SelectItem value="/locations/countries">Countries</SelectItem>
            <SelectItem value="/locations/top-level-regions">TLRs</SelectItem>
          </SelectContent>
        </Select>
        <SearchInput />
      </div>
      <div className="flex flex-row gap-4 items-center">
        <ExportLocationsButton />
        <AddNewButton />
        <PageSizeSelect />
      </div>
    </div>
  );
}

function AddNewButton() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex ml-auto">
      <Button
        size="sm"
        onClick={() => {
          navigate(`${location.pathname}/add`);
        }}
      >
        <PlusIcon className="mr-2 h-4 w-4" /> Add New
      </Button>
    </div>
  );
}

function SearchInput() {
  const [value, setValue] = useState("");
  const emit = useEmit<string>("loc:search");
  const debouncedEmit = useDebounce(emit, 300);

  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.currentTarget.value;
    setValue(value);
    debouncedEmit(value);
  };

  useEffect(() => {
    debouncedEmit("");
  }, []);

  return (
    <div className="w-80">
      <Input
        value={value}
        onChange={onChange}
        type="search"
        placeholder="Name filter"
        className="w-full bg-white"
        style={{ padding: "0.5rem" }}
      />
    </div>
  );
}

function PageSizeSelect() {
  const [value, setValue] = useState("10");
  const emit = useEmit<number>("loc:page-size");

  const onValueChange = (value: string) => {
    setValue(value);
    emit(parseInt(value));
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Page size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="5">Show: 5 at once</SelectItem>
          <SelectItem value="10">Show: 10 at once</SelectItem>
          <SelectItem value="20">Show: 20 at once</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
